import dayjs from 'dayjs';

import type {ConferenceApiModel} from '../../../api/conference';

import {datetimeObjToISOString, ISOStringToDatetimeObj} from '../../datetime';

export const ALLOWED_CONFERENCE_START_BEFORE_MINS = 10;

export const getConferenceAbleToStartDate = (conference: ConferenceApiModel) =>
  ISOStringToDatetimeObj(
    dayjs(datetimeObjToISOString(conference.start_date))
      .subtract(ALLOWED_CONFERENCE_START_BEFORE_MINS, 'minute')
      .startOf('minute')
      .toISOString(),
  );
